document.addEventListener("DOMContentLoaded", function() {

  /*
     1) In einem Schritt alle Sonder-Syntaxen ersetzen
     ------------------------------------------------ */

  function replaceSpecialSyntax(text) {
    // a) ****[[...]]*** => rotating text + rotes Highlight
    text = text.replace(/\*\*\*\*\[\[(.*?)\]\]\*\*\*\*/g, function(match, content) {
      const words = content.split('|');
      // Nimm das erste Wort als sichtbaren Text
      const firstWord = words[0];
      return '<span class="rotating-text highlight-text-red" '
           +       'data-words="' + content + '">'
           +        firstWord
           + '</span>';
    });

    // b) ***[[...]]*** => rotating text + blaues Highlight
    text = text.replace(/\*\*\*\[\[(.*?)\]\]\*\*\*/g, function(match, content) {
      const words = content.split('|');
      // Nimm das erste Wort als sichtbaren Text
      const firstWord = words[0];
      return '<span class="rotating-text highlight-text-blue" '
           +       'data-words="' + content + '">'
           +        firstWord
           + '</span>';
    });

    // c) [[...]] => nur rotating text (kein Highlight)
    text = text.replace(/\[\[(.*?)\]\]/g, function(match, content) {
      const words = content.split('|');
      return '<span class="rotating-text" '
           +       'data-words="' + content + '">'
           +        words[0]
           + '</span>';
    });

    // d) ****Text**** => rotes Highlight
    text = text.replace(/\*\*\*\*(.*?)\*\*\*\*/g, '<span class="highlight-text-red">$1</span>');

    // e) ***Text*** => blaues Highlight
    text = text.replace(/\*\*\*(.*?)\*\*\*/g, '<span class="highlight-text-blue">$1</span>');

    // f) **Text** => weißes Highlight
    text = text.replace(/\*\*(.*?)\*\*/g, '<span class="highlight-text-white">$1</span>');

    // g) [hint]Text[/hint] => word-hint Klasse
    text = text.replace(/\[hint\](.*?)\[\/hint\]/g, '<span class="word-hint">$1</span>');

    return text;
  }

  // Läuft rekursiv durch den gesamten DOM und ersetzt Text in Textknoten
  function walkDom(element) {
    if (element.nodeType === Node.TEXT_NODE) {
      const originalText = element.textContent;
      const replacedText = replaceSpecialSyntax(originalText);

      if (replacedText !== originalText) {
        const wrapper = document.createElement('span');
        wrapper.innerHTML = replacedText;
        element.replaceWith(wrapper);
      }
    } else {
      element.childNodes.forEach(walkDom);
    }
  }

  // 1. Syntax im Body ersetzen
  walkDom(document.body);

  /*
     2) Rotations-Funktion starten
     ---------------------------- */
  function startRotatingText() {
    const rotatingElements = document.querySelectorAll('.rotating-text');
    rotatingElements.forEach(function(element) {
      const words = element.getAttribute('data-words').split('|');
      let currentIndex = 0;

      // Falls requestAnimationFrame nicht verfügbar, nur das erste Wort anzeigen
      if (typeof requestAnimationFrame === 'undefined') {
        element.textContent = words[0];
        return;
      }

      // 1. Wechsel direkt beim Laden
      setTimeout(function() {
        element.style.transition = 'opacity 0.5s ease-in-out';
        element.style.opacity = '0';
        setTimeout(function() {
          currentIndex = (currentIndex + 1) % words.length;
          element.textContent = words[currentIndex];
          element.style.opacity = '1';
        }, 500);
      }, 0);

      // Danach alle ~4 Sekunden erneut
      setInterval(function() {
        element.style.transition = 'opacity 0.5s ease-in-out';
        element.style.opacity = '0';
        setTimeout(function() {
          currentIndex = (currentIndex + 1) % words.length;
          element.textContent = words[currentIndex];
          element.style.opacity = '1';
        }, 500);
      }, 4000);
    });
  }

  // Rotierende Elemente animieren
  startRotatingText();

});
